module.exports = __webpack_public_path__ + "img/cards.e7d04cb.png";